import React, {ReactNode, useCallback, useEffect} from 'react';

import {useLocation, useNavigate} from 'react-router-dom';
import logError from 'src/utils/errors/logError';

import {featureFlags} from '@/config/featureFlags';
import {useFirestoreAuth} from '@/dataSource/src/api/firebase/useFirestoreAuth';

interface Props {
  children: ReactNode;
}

const AuthenticationGuard: React.FC<Props> = ({children}) => {
  const navigate = useNavigate();
  const {pathname} = useLocation();
  const isSignInDisabled = featureFlags.isSignInDisabled;

  const {handleGetAuthByPass} = useFirestoreAuth();

  const handleVerifyPathname = useCallback(async () => {
    const authByPass = await handleGetAuthByPass();
    if (authByPass.length === 0) {
      return;
    }

    const isByPassExist = authByPass.some(key =>
      pathname.toLowerCase().includes(key.id.toLowerCase()),
    );

    if (isSignInDisabled && isByPassExist) {
      navigate(pathname, {replace: true});
      return;
    }

    if (isSignInDisabled && pathname.toLowerCase().includes('sign-in')) {
      navigate('/authentication/download-app', {replace: true});
    }
  }, [handleGetAuthByPass, isSignInDisabled, pathname, navigate]);

  useEffect(() => {
    handleVerifyPathname().catch(error => {
      logError(error, {
        fileName: 'AuthenticationGuard.tsx',
        functionName: 'handleVerifyPathname',
        customTitle: 'Auth - AuthenticationGuard - Failed to verify pathname',
      });
    });
  }, [pathname, navigate, isSignInDisabled, handleVerifyPathname]);

  return <>{children}</>;
};

export default AuthenticationGuard;
